module.exports = __webpack_public_path__ + "static/media/woo3.cdcdbf07.png";